import { render } from "./Board.vue?vue&type=template&id=28d6621a"
import script from "./Board.vue?vue&type=script&lang=js"
export * from "./Board.vue?vue&type=script&lang=js"

import "./Board.vue?vue&type=style&index=0&id=28d6621a&lang=scss"
script.render = render

export default script